/* Masque la barre d'achat collante de la fiche quand le configurateur 3D est à l'écran */
(function () {
  function init() {
    var cfg = document.getElementById('pc-config');
    if (!cfg || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (en) { document.body.classList.toggle('pc-cfg-in-view', en[0].isIntersecting); }, { threshold: 0.15 }).observe(cfg);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
